


export class CostReviewMetering {
  manufacturer!: string;
  installation!: number;
  unitsFurnishedBy!: number;
  unitsInstalledBy!: number;
  unitsWiredBy!: number;
  isMeteringApplicable!: boolean;
}
